import { Box, Stack } from '@mui/material'

type Props = {
  /** Size of a single dot in pixels */
  size: number
}

export const AnimatedLoader = ({ size }: Props) => {
  return (
    <Stack
      direction="row"
      spacing={`${size * 1.5}px`}
      sx={{
        '& > *:nth-of-type(1)': {
          animation: 'dot-elastic-left 0.8s infinite linear',
        },
        '& > *:nth-of-type(2)': {
          animation: 'dot-elastic-center 0.8s infinite linear',
        },
        '& > *:nth-of-type(3)': {
          animation: 'dot-elastic-right 0.8s infinite linear',
        },
        '@keyframes dot-elastic-left': {
          '0%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '25%': {
            transform: `scale(1, 1.5) translateY(-${size / 2}px)`,
            background: '#6100DC',
          },
          '50%': {
            transform: `scale(1, 0.67) translateY(0)`,
          },
          '75%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '100%': {
            transform: `scale(1, 1) translateY(0)`,
          },
        },
        '@keyframes dot-elastic-center': {
          '0%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '25%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '50%': {
            transform: `scale(1, 1.5) translateY(-${size / 2}px)`,
            background: '#6100DC',
          },
          '75%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '100%': {
            transform: `scale(1, 1) translateY(0)`,
          },
        },
        '@keyframes dot-elastic-right': {
          '0%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '25%': {
            transform: `scale(1, 1) translateY(0)`,
          },
          '50%': {
            transform: `scale(1, 0.67) translateY(0)`,
          },
          '75%': {
            transform: `scale(1, 1.5) translateY(-${size / 2}px)`,
            background: '#6100DC',
          },
          '100%': {
            transform: `scale(1, 1) translateY(0)`,
          },
        },
      }}
    >
      {[...Array(3).keys()].map(index => (
        <Box
          key={index}
          sx={{
            width: size,
            height: size,
            borderRadius: '50%',
            bgcolor: '#6100dc66',
          }}
        ></Box>
      ))}
    </Stack>
  )
}
